import { useQuery } from '@tanstack/react-query';
import { notesService } from '../api/notes.service';
import { NOTE_KEYS } from './queryKeys';

/** Fetches version summaries for a note, newest first — feeds `NoteHistoryDialog`. */
export function useNoteHistory(noteId: string | undefined, page = 1) {
  return useQuery({
    queryKey: NOTE_KEYS.history(noteId ?? '', page),
    queryFn: ({ signal }) => notesService.getHistory(noteId as string, page, 50, signal),
    staleTime: 60_000,
    enabled: !!noteId,
  });
}
